import { Button, Col, Form, Row, Select } from 'antd';
import { FC } from 'react';

import { ButtonSuccess } from '../../../../../common/components';
import { AppFormProps } from '../../../../../common/interfaces';
import { defineInputStatus } from '../../../../../common/utils';
import { DomainsAllAutocompleteBySite } from '../../../components';
import { DomainRegluingsFormFields, DomainRegluingsFormInputs, DomainVisitors } from '../../../domains.interfaces';

interface Props
  extends AppFormProps<
    Pick<typeof DomainRegluingsFormInputs, 'ForVisitor' | 'TargetDomainId' | 'IsAutoUpdate'>,
    Pick<DomainRegluingsFormFields, 'forVisitor' | 'isAutoUpdate' | 'targetDomainId'>
  > {
  siteId: string;
  domainId: string;
}

export const DomainRegluingsCreateFormView: FC<Props> = ({
  form,
  formName,
  formType,
  initialValues,
  isFormLoading,
  validationSchema,
  siteId,
  formErrors,
  handleBack,
  handleFinish,
  handleFinishFailed
}) => {
  return (
    <Form
      form={ form }
      name={ formName }
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      initialValues={ initialValues }
      disabled={ isFormLoading }
      autoComplete="off"
      onFinish={ handleFinish }
      onFinishFailed={ handleFinishFailed }
    >
      <Form.Item
        label="Бот"
        name={ DomainRegluingsFormInputs.ForVisitor }
        hasFeedback
        help={ formErrors?.forVisitor }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.forVisitor) }
        rules={ validationSchema.forVisitor }
      >
        <Select allowClear>
          <Select.Option value={ DomainVisitors.Any }>Будь-хто</Select.Option>
          <Select.Option value={ DomainVisitors.GoogleBot }>Google Bot</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="Цільовий домен"
        name={ DomainRegluingsFormInputs.TargetDomainId }
        hasFeedback
        help={ formErrors?.targetDomainId }
        validateStatus={ defineInputStatus(isFormLoading, formErrors?.targetDomainId) }
        rules={ validationSchema.targetDomainId }
      >
        <DomainsAllAutocompleteBySite siteId={ siteId }/>
      </Form.Item>

      <Form.Item wrapperCol={{ span: 24 }} noStyle>
        <Row gutter={ [16, 16] }>
          <Col flex={ 'auto' }>
            <ButtonSuccess block loading={ isFormLoading } type="primary" htmlType="submit">
              { formType === 'edit' ? 'Зберегти' : 'Додати' }
            </ButtonSuccess>
          </Col>
          <Col>
            <Button type="default" onClick={ handleBack }>
              Скасувати
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};
